export default "__VITE_ASSET__OwOLYgnL__"